import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import security from "../../services/security.js";
import messaging from "../../services/messagingv2.js";

class JobblefooterController {
  constructor($http, $localStorage, $state, AuthService, SecurityService, Messagingv2Service, $rootScope, $location, TrackingService, $timeout) {
    this.name = "jobblefooter";

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$rootScope = $rootScope;
    this.$tracking = TrackingService;
    this.$security = SecurityService;
    this.$messagingv2 = Messagingv2Service;
    this.currentUser = this.$auth.getUserData();
    this.$location = $location;
    this.loadLocalLytics = false;
    this.$timeout = $timeout;
    this.counter = 0;

    var _this = this;

    if (!_this.$rootScope.localytics) {
      if (!_this.loadLocalLytics) {
        _this.$timeout(function () {
          _this.loadLocalLytics = true;
          _this.$rootScope.localytics = true;
        });
      }
    }
  }
}

JobblefooterController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "auth",
  "security",
  "messagingv2",
  "$rootScope",
  "$location",
  "tracking",
  "$timeout",
];

export default JobblefooterController;



// WEBPACK FOOTER //
// ./client/app/common/jobblefooter/jobblefooter.controller.js